
import Component from "vue-class-component"
import Page from "@/report/pages/Page.vue"
import AbstractPage from "@/report/pages/AbstractPage.vue"

@Component({name: "BackPage", components: {Page}})
export default class BackPage extends AbstractPage {}
